import Skeleton, { SkeletonCard } from '@/shared/components/Skeleton';
import { useIsMobile } from '@/shared/hooks/useMediaQuery';

export default function BudgetsSkeleton({ theme: t }) {
  const mobile = useIsMobile();

  return (
    <div>
      {/* Stat cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: mobile ? '1fr' : '1fr 1fr 1fr',
        gap: 14,
        marginBottom: 20,
      }}>
        {[0, 1, 2].map((i) => (
          <SkeletonCard key={i} theme={t} height={80} />
        ))}
      </div>

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <Skeleton width={140} height={14} theme={t} />
        <Skeleton width={120} height={32} borderRadius={8} theme={t} />
      </div>

      {/* Category rows */}
      {[0, 1, 2, 3, 4].map((i) => (
        <div key={i} style={{
          background: t.cardBg, borderRadius: 14, padding: 18,
          border: '1px solid ' + t.cardBorder, marginBottom: 12,
          display: 'flex', flexDirection: 'column', gap: 10,
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Skeleton width="30%" height={14} theme={t} />
            <Skeleton width={80} height={14} theme={t} />
          </div>
          <Skeleton width="100%" height={8} borderRadius={4} theme={t} />
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Skeleton width="25%" height={11} theme={t} />
            <Skeleton width="20%" height={11} theme={t} />
            <Skeleton width="15%" height={11} theme={t} />
          </div>
        </div>
      ))}
    </div>
  );
}
